module.exports = __webpack_public_path__ + "static/media/display-3@768.f18c8b23.png";